// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25362
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25362
import { eventTrackingUtils } from '@/utils/eventTrackingUtils'
interface IExpoTrackParamsRecord {
  /** 订单跟踪弹层曝光 */
OrderFollow_LayerExpo:{
/** 订单id  */
orderId: string;
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5';
/** 包裹数量  */
packageNum: string;
}
  /** 包裹选项曝光 */
OrderTrailFollow_PackageExpo:{
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5';
/** 订单id  */
orderId: string;
/** 包裹数量  */
packageNum: string;
/** 位置  */
index: number;
}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 订单跟踪弹层曝光 */
  OrderFollow_LayerExpo:'OrderFollow_LayerExpo',
/** 包裹选项曝光 */
  OrderTrailFollow_PackageExpo:'OrderTrailFollow_PackageExpo',
})

interface IClickTrackParamsRecord {
  /** 订单跟踪弹层关闭 */
OrderFollow_Close:{
/** 订单id  */
orderId: string;
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5';
/** 包裹数量  */
packageNum: string;
}
  /** 物流单号复制按钮 */
OrderFollow_TrackIdCopy:{
/** 订单id  */
orderId: string;
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5';
/** 包裹数量  */
packageNum: string;
}
  /** 包裹选项点击 */
OrderTrailFollow_Package:{
/** 订单状态 1-unpaid,3-processing-待发货,8-processing-已发货,6-cancelled,5-completed */
orderStatus: | '1'| '3'| '8'| '6'| '5';
/** 订单id  */
orderId: string;
/** 包裹数量  */
packageNum: string;
/** 位置  */
index: number;
}
}

const sendClickTrack = {
  /** 点击事件上报-订单跟踪弹层关闭 */
OrderFollow_Close: (json_param: IClickTrackParamsRecord['OrderFollow_Close']) => {
    eventTrackingUtils.submitCL({event_id:'OrderFollow_Close',json_param});
  },
  /** 点击事件上报-物流单号复制按钮 */
OrderFollow_TrackIdCopy: (json_param: IClickTrackParamsRecord['OrderFollow_TrackIdCopy']) => {
    eventTrackingUtils.submitCL({event_id:'OrderFollow_TrackIdCopy',json_param});
  },
  /** 点击事件上报-包裹选项点击 */
OrderTrailFollow_Package: (json_param: IClickTrackParamsRecord['OrderTrailFollow_Package']) => {
    eventTrackingUtils.submitCL({event_id:'OrderTrailFollow_Package',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
}
export type {
  IExpoTrackParamsRecord,
}